<app-invoice-details-component [invoiceId]="invoiceId" [isPharmacist]="true"></app-invoice-details-component>
